/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import dayjs from 'dayjs';
import { ISurveyHeaders } from 'app/shared/model/survey-headers.model';
import { IGlucoUser } from 'app/shared/model/gluco-user.model';
import { CompletedByType } from 'app/shared/model/enumerations/completed-by-type.model';

export interface IPatientSurvey {
  id?: string;
  completedOn?: dayjs.Dayjs | null;
  completedByType?: keyof typeof CompletedByType | null;
  completedById?: string | null;
  active?: boolean;
  cursor?: number;
  lastupdated?: number;
  microSec?: number;
  timestampentry?: number;
  survey?: ISurveyHeaders;
  patient?: IGlucoUser;
}

export const defaultValue: Readonly<IPatientSurvey> = {
  active: false,
};
